import { tooltip } from '@svelte-plugins/tooltips';

export function reactiveTooltip(node, params) {
    let instance: any;

    function init(p) {
        if (p?.enabled) {
            instance = tooltip(node, p);
        }
    }

    function update(p) {
        if (p?.enabled) {
            if (instance) {
                // forward updates to tooltip action
                instance.destroy?.();
            }
            instance = tooltip(node, p);
        } else {
        // disable tooltip if it was enabled
            instance?.destroy?.();
            instance = null;
        }
    }

    function destroy() {
        instance?.destroy?.();
    }

    init(params);

    return { update, destroy };
}